import React from 'react';
import ReactDOM from 'react-dom/client'; // UPDATED: Import from 'react-dom/client'
import './index.css';
import App from './App';
import './i18n';
import { PATH_LANG, PREFIXES } from './langPath';

// Consolidate legacy ?lang=xx links onto the corresponding URL tree. A real 301
// needs the VPS (see report); this at least stops the parameter URL being
// treated as a separate page and sends humans to the right document.
try {
    const params = new URLSearchParams(window.location.search);
    const wanted = (params.get('lang') || '').toLowerCase();
    if (PREFIXES[wanted] && PATH_LANG !== wanted) {
        const { pathname, hash } = window.location;
        params.delete('lang');
        const qs = params.toString();
        window.location.replace(
            `${PREFIXES[wanted]}${pathname === '/' ? '' : pathname}${qs ? `?${qs}` : ''}${hash || ''}`
        );
    }
} catch (e) {
    // ignore - never block rendering on this
}

// 1. Create the root element using the modern API
const root = ReactDOM.createRoot(document.getElementById('root'));

// 2. Render your application inside the root
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);